import styles from "./style.module.scss";
import TopImage from "src/assets/personal_policy_top_image.jpg";

export const TopSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.backgroundImg}>
        <img src={TopImage} alt="Personal Policy" />
        <div className={styles.titleBox}>
          <h1>Personal policy</h1>
          <p>個人情報保護方針</p>
        </div>
      </div>
    </section>
  );
};
